import React, { Component } from 'react';

import { ListLayout, CardLayout, TableLayout } from '../Menu/Stock/containers/Layout';

import NewBoxAssociation from '../Menu/module/paygoNewBoxAssociation';
import ChangeStatusBox from '../Menu/module/paygoChangeStatusBox.jsx';
import SwitchBox from '../Menu/module/switchBox.jsx';
import { isEmpty } from "lodash";
import { Button, TableHead, TableRow, TableCell, TableBody, Grid, Box } from '@material-ui/core';
import { AddCircleOutlineRounded, RefreshRounded, EditRounded } from '@material-ui/icons';
import SearchBar from './Layouts/SeachBar';
import PageAdmin from './Layouts/PageAdmin';
import SearchBarAction from './Layouts/SearchBarAction';
import CardButton from '../../commonModules/interface/CardButton';
import Dialog from '../../commonModules/interface/Dialog';
import { indigo, pink } from '@material-ui/core/colors';

class BoxesList extends Component {
    state = { 
        new: false,
        statusBox: false,
        switchBox: false,
        list: [],
        
     }
    
    componentDidMount = async () => {
        const { BOXES } = this.props;
        if( !BOXES ){
            await this.props.fetchBoxes()
            await this.props.fetchLinkedBoxes()
            await this.props.fetchFreeBoxes()
        }
        
        this.filterList()
        // this.getBoxList()
    }
    filterList = (list) => {
        if( !list ){
            if(!isEmpty(this.props.BOXES) ){
                list = Object.keys(this.props.BOXES)
            } else {
                list = []
            }
        }
        this.setState({
            list
        })
    }
    
    render() {
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        const { BOXES } = this.props;
        let actions =[
            { 
                openAction : () => this.setState({ new: true }),
                icon: <AddCircleOutlineRounded color="secondary"/>,
                title: "Nouveau Système"
            },
            { 
                openAction : () => this.setState({ switchBox: true }),
                icon: <RefreshRounded style={{ color: pink[200] }}/>,
                title: "Remplacement"
            },
            { 
                openAction : () => this.setState({ statusBox: true }),
                icon: <EditRounded style={{ color: indigo[200] }} />,
                title: "Changement Statut"
            },
        ]
        
        // <Grid item sm={4} xs={12}>
        //                 <Button 
        //                     style={{ backgroundColor: "amber" }} 
        //                     openAction : {()=>
        //                         this.setState({ switchBox: true })
        //                     }
        //                     icon: <RefreshRounded />
        //                 >
        //                     {/* <i className="zmdi zmdi-refresh zmdi-hc-fw"></i>  */}
        //                     Remplacement
        //                 </Button>
        //             </Grid>
        //             <Grid item sm={4} xs={12}>
        //                 <Button 
        //                     style={{ backgroundColor: "bluegray" }} 
        //                     openAction : {()=>
        //                         this.setState({ statusBox: true })
        //                     }
        //                     icon: <EditRounded />
        //                 >
        //                     {/* <i className="zmdi zmdi-edit zmdi-hc-fw"></i> */}
        //                     Changement Statut
        //                 </Button>
        //             </Grid>
        return (
            <PageAdmin title="Systèmes et Boxes">
                {this.state.new &&
                    <NewBoxAssociation onCloseOverlay={()=>
                        this.setState({ new: false })}/>
                }
                {this.state.switchBox &&
                    <SwitchBox 
                        onCloseOverlay={()=>
                        this.setState({ switchBox: false })}
                        {...this.props}
                    />
                }
                {this.state.statusBox &&
                    <ChangeStatusBox onCloseOverlay={()=>
                        this.setState({ statusBox: false })}/>
                }                

                {this.state.openFormTypes &&
                    <Dialog
                        title="Nouveau"
                        block={true}
                        close={() => this.setState({ 
                            openFormTypes: false,
                            new: false ,
                            newReport: false ,
                            newQuotation: false ,
                            newSav: false ,
                            newComplementary: false
                        }) }
                    >
                        {actions.map(action =>
                            <CardButton
                                action={action.openAction}
                                icon={action.icon}
                                title={action.title}
                            />
                        )}
                    </Dialog>
                }
                
                <SearchBarAction list={ BOXES } filterList={this.filterList} action={ () => this.setState({ openFormTypes: true}) }/>
                        
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell component="th">ID Box</TableCell>
                            <TableCell component="th">Numero SIM</TableCell>
                            {/* <TableCell>Options</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {BOXES && this.state.list.map( ID => {
                            let box = BOXES[ID]
                            return(
                                <TableRow key={ box.idBox }>
                                    <TableCell>{ box.idBox }</TableCell>
                                    <TableCell>{ box.simNumber }</TableCell>
                                    {/* <TableCell> <button className="btn btn-warning" onClick={()=> this.setState({dialogChangeBox : true, boxID: box.idBox})}><i className="zmdi zmdi-refresh-sync zmdi-hc-fw"></i></button> </TableCell> */}
                                </TableRow>
                            )
                        } )
                    }
                    </TableBody>
                </TableLayout>
            </PageAdmin>
        );
    }
}


export default BoxesList 